import { Vue, Component, Emit, Prop } from 'vue-property-decorator'
import moment from 'moment'

@Component
export default class CustomerFilterComponent extends Vue {
  from: string = new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().substr(0, 10)
  to: string = new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).toISOString().substr(0, 10)
  fromModal: boolean = false
  toModal: boolean = false

  get fromComputed () {
    return moment(this.from).format('DD/MM/YYYY')
  }

  get toComputed () {
    return moment(this.to).format('DD/MM/YYYY')
  }

  @Prop(Boolean)
  open!: boolean

  @Emit()
  toggle (event:boolean) {
  }

  @Emit()
  filter () {
    return {
      from: this.from,
      to: this.to
    }
  }
}
